import { Button } from "@upstageai/ui";

import useAuth from "../../hooks/useAuth";

export default function LoginCard() {
  const { login } = useAuth();
  return (
    <div className="m-auto flex flex-col items-center">
      <div className="w-[400px] rounded-lg bg-background p-8 shadow-lg">
        <div className="mb-4 text-center text-xl font-medium">
          Welcome to the Solar Box
        </div>
        <Button
          type="submit"
          size="xl"
          variant="primary"
          onClick={() => {
            login("test@test.com", "test1234");
          }}
        >
          SSO Log in
        </Button>
      </div>
    </div>
  );
}
